import styled from 'styled-components';
import { rem } from 'polished';
var Outer = styled.div.withConfig({
  displayName: "Outer",
  componentId: "sc-1neqij2-0"
})(["display:flex;justify-content:center;padding:0 ", ";position:relative;margin:", " 0;width:100%;z-index:1;"], rem(24), rem(40));
export default Outer;